import { Redirect, Route } from "react-router";

const ProtectedRoute = ({ component: Component, ...rest }) => {
    const getUser = () => {
        let user = JSON.parse(localStorage.getItem("user_info"));
        return user;
    }
    return (<Route {...rest} render={props =>  getUser() ? <Component {...props} /> : <Redirect to="/login" /> } />);
}

export default ProtectedRoute;